import Accordion from "./ImageContentTabs";
customElements.define('image-content-tabs', Accordion);